import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps } from '@chakra-ui/react';
import { FUNDING_LANDING_ILLUSTRATIONS } from '@src/components/sco/Funding/FundingLandingIllustrations/fundingLandingIllustrations';
import { prepareLandingIllustrationSvg } from '@src/components/sco/GenericLP/prepareLandingIllustrationSvg';
import React from 'react';
export type AnalyzingIllustrationProps = BoxProps & {
  momentIndex: number;
};

/**
 * Renders the animated SVG for a given analyzing moment.
 * Markup + CSS keyframes are ported from the inline diagnostic HTML;
 * remounting via `key` restarts the animation when the moment changes.
 */
export const AnalyzingIllustration: React.FC<AnalyzingIllustrationProps> = t0 => {
  const $ = _c(11);
  let boxProps;
  let momentIndex;
  if ($[0] !== t0) {
    ({
      momentIndex,
      ...boxProps
    } = t0);
    $[0] = t0;
    $[1] = boxProps;
    $[2] = momentIndex;
  } else {
    boxProps = $[1];
    momentIndex = $[2];
  }
  const rawSvg = FUNDING_LANDING_ILLUSTRATIONS[momentIndex];
  if (!rawSvg) {
    return null;
  }
  let t1;
  if ($[3] !== rawSvg) {
    t1 = prepareLandingIllustrationSvg(rawSvg);
    $[3] = rawSvg;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const svg = t1;
  let t2;
  if ($[5] !== svg) {
    t2 = {
      __html: svg
    };
    $[5] = svg;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      "& svg": {
        display: "block",
        width: "100%",
        height: "auto"
      }
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== boxProps || $[9] !== t2) {
    t4 = <Box dangerouslySetInnerHTML={t2} lineHeight={0} marginX="auto" maxWidth="312px" width="full" css={t3} {...boxProps} />;
    $[8] = boxProps;
    $[9] = t2;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};